import { isStatusValid } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE } from '@mchat-rf/consulta-seguimento/validator-consultaSeguimento'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta01Model } from './model-consultaSeguimentoPergunta01'
import {
  hasPergunta01ExemplosFalhouAnySim,
  hasPergunta01ExemplosPassouAnySim,
  isPergunta01ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta01'

export const validatorConsultaSeguimentoPergunta01 = createValidator<ConsultaSeguimentoPergunta01Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_01_HEADER: required,
    PERGUNTA_01_EXEMPLOS: createValidator<ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']>({
      FALHOU: createValidator<NonNullable<ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']>['FALHOU']>({
        IGNORA_VOCE: required,
        OLHA_AO_REDOR: required,
        OLHA_PARA_DEDO_DO_GENITOR: required,
      }),
      PASSOU: createValidator<NonNullable<ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']>['PASSOU']>({
        OLHA_PARA_OBJETO: required,
        APONTA_PARA_OBJETO: required,
        OLHA_E_COMENTA_SOBRE_OBJETO: required,
        OLHA_QUANDO_GENITOR_APONTA: required,
      }),
    }),
  },
  (values: ConsultaSeguimentoPergunta01Model, errors: ErrorObject<ConsultaSeguimentoPergunta01Model>) => {
    const isPerguntaExemplosAllNao = isPergunta01ExemplosAllNao(values?.PERGUNTA_01_EXEMPLOS)
    const hasPerguntaExemplosPassouAnySim = hasPergunta01ExemplosPassouAnySim(values?.PERGUNTA_01_EXEMPLOS)
    const hasPerguntaExemplosFalhouAnySim = hasPergunta01ExemplosFalhouAnySim(values?.PERGUNTA_01_EXEMPLOS)

    if (isPerguntaExemplosAllNao) {
      errors.PERGUNTA_01_EXEMPLOS = CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE
    }

    if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
      errors.PERGUNTA_01_MAIOR_FREQUENCIA = required(values?.PERGUNTA_01_MAIOR_FREQUENCIA)
    }

    return errors
  }
)
